/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { getInfCLogger } from '@infodata-group/inf-commons-core';
import {ModelProperty} from './model-property';
import {StandardAction} from '../tool/action/standard-action';

const logger = getInfCLogger('PropertyGroup');

export class PropertyGroup {

  public id: string;
  public title: string;
  public icon: string;
  public column: number;
  public properties: ModelProperty[];
  public actions: StandardAction[] = [];

  constructor(id: string, title: string, icon?: string) {
    this.title = title;
    this.id = id;
    this.icon = icon;
    this.column = 1;
    this.properties = [];
    this.actions = [];
  }

  public get length(): number {
    return this.properties.filter((p) => p.showOnForm).length;
  }

  copy(): PropertyGroup {
    return new PropertyGroup(this.id, this.title, this.icon);
  }

  public addProperty(property: ModelProperty): void {
    if (this.properties.find(x => x.id === property.id)) {
      logger.warn(`Property "${property.id}" already exist in group "${this.id}"`);
      return;
    }
    this.properties.push(property);
  }
}
